import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import LocaleConfig from 'locale-config';

const { name: nameConfig } = LocaleConfig;

function Contact(data) {
    if (data) {
        _.extend(this, data);
    }
}

function append(sb, fieldId, value) {
    if (!_.isEmpty(value) && _.includes(nameConfig.visibleFields, fieldId)) {
        sb.push(value);
    }
}

Contact.prototype.getDisplayName = function (delimiter, defaultName) {
    const lastName = this.lastNameKanji || this.lastName;
    const firstName = this.firstNameKanji || this.firstName;
    const result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            append(result, 'FirstName', firstName);
            append(result, 'LastName', lastName);
            break;
        case 'France':
            append(result, 'LastName', lastName);
            append(result, 'FirstName', firstName);
            break;

        case 'Japan':
            append(result, 'LastName', lastName);
            append(result, 'FirstName', firstName);
            break;
        default:
            break;
    }
    return result.join(delimiter) || defaultName;
};

Contact.prototype.getFullNameWithoutSuffix = function () {
    const { lastName, firstName } = this;
    const middleName = this.middleName || '';
    const result = [];
    append(result, 'FirstName', firstName);
    append(result, 'MiddleName', middleName);
    append(result, 'LastName', lastName);
    return result.join(' ');
};

Contact.prototype.getFullName = function (nameSuffixTypelist, translator) {
    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };

    const lastName = this.lastNameKanji || this.lastName;
    const firstName = this.firstNameKanji || this.firstName;
    const { middleName } = this;
    const result = [];

    append(result, 'FirstName', firstName);
    append(result, 'MiddleName', middleName);
    append(result, 'LastName', lastName);
    append(result, 'Suffix', this.suffix ? getTypeKeyDescription(nameSuffixTypelist.getCode(this.suffix).name) : '');
    return result.join(' ');
};

Contact.prototype.getFirstAndLastName = function () {
    const { lastName, firstName } = this;
    const result = [];
    append(result, 'FirstName', firstName);
    append(result, 'LastName', lastName);
    return result.join(' ');
};

export default Contact;
